<template>
  <v-card
    elevation="0"
    class="h-full rounded-lg"
    :class="{ 'setting-card--clickable': canClick }"
    @click.native="onCardClick"
    :ripple="disableClickWhenActive && isActive ? false : true"
  >
    <v-alert :color="alertColor" class="mb-0 h-full "  text>
      <div>
        <div class="d-flex align-start gap-1 mb-1">
          <slot name="icon">
            <v-icon v-if="icon" :color="alertColor" small left>
              {{ icon }}
            </v-icon>
          </slot>
          <h6 class="mb-0 lh-1">
            <slot name="title">{{ title }}</slot>
          </h6>
          <v-spacer />
          <slot name="control" :active="isActive" :toggle="toggle">
            <v-switch
              v-if="showSwitch"
              :input-value="isActive"
              :color="color"
              :disabled="disabled"
              hide-details
              class="ma-0 pt-0 mr-n3 mt-n1"
              dense
              @click.stop
              @change="onSwitchChange"
            />
          </slot>
        </div>

        <p v-if="description || $slots.description" class="mb-0 text-caption lh-2">
          <slot name="description">{{ description }}</slot>
        </p>

        <div v-if="$scopedSlots.default">
          <slot :active="isActive" :toggle="toggle" />
        </div>
      </div>
    </v-alert>
  </v-card>
</template>

<script>
export default {
  name: "SettingCard",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "success",
    },
    inactiveColor: {
      type: String,
      default: "secondary",
    },
    showSwitch: {
      type: Boolean,
      default: true,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    disableClickWhenActive: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive() {
      return !!this.value;
    },
    alertColor() {
      return this.isActive ? this.color : this.inactiveColor;
    },
    canClick() {
      if (this.disabled || !this.clickable) return false;
      if (this.disableClickWhenActive && this.isActive) return false;
      return true;
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit("input", !this.isActive);
    },
    onCardClick() {
      if (!this.canClick) return;
      this.toggle();
    },
    onSwitchChange(newValue) {
      if (this.disabled) return;
      this.$emit("input", !!newValue);
    },
  },
};
</script>

<style scoped>
.setting-card--clickable {
  cursor: pointer;
}
</style>
